import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetTwoFACodeRequest, UpdateTwoFAUsageRequest } from '@/api';
import { TwoFACodeData } from '../models';

export interface FaDataSliceState {
  data: TwoFACodeData;
  loading: boolean;
  error: string | null;
}

const initialState: FaDataSliceState = {
  data: null,
  loading: false,
  error: null,
};

const twoFASlice = createSlice({
  name: 'twoFA',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<TwoFACodeData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    getTwoFACode: (state) => ({
      ...state,
      error: null,
      loading: true,
    }),
    enableTwoFA: (state, action: PayloadAction<UpdateTwoFAUsageRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    disableTwoFA: (state, action: PayloadAction<UpdateTwoFAUsageRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { twoFASlice };
